import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/topicgroup.m.css';
const factory = create({ theme }).properties();
export const BackToTop = factory(({ properties, middleware: { theme } }) => {
    const themeCss = theme.classes(css);
    const { text, topicid } = properties();
    return v('div', {
        classes: [themeCss.action],
        role: 'button',
        xqa: 'back-to-top-button',
        tabIndex: 0,
        onclick: (event) => {
            event && event.stopPropagation();
            window.scrollTo(0, 0);
            publish('scroll-to-topic', topicid);
        },
        onkeydown: (event) => {
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    window.scrollTo(0, 0);
                    publish('scroll-to-topic', topicid);
            }
        }
    }, [v('div', { classes: [themeCss.actionText] }, [text])]);
});
export default BackToTop;
